import Component from "@glimmer/component";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";

export default class CommuniteqAdminNotice extends Component {
  @service siteSettings;
  @service currentUser;

  get shouldShow() {
    return (this.currentUser) && (this.currentUser.staff) && (this.siteSettings.communiteq_admin_notice !== "");
  }

  get adminNotice() {
    return htmlSafe(this.siteSettings.communiteq_admin_notice);
  }

  <template>
    {{#if this.shouldShow}}
      <div class="communiteq-admin-notice" style="background-color: #fefefe; border: 4px solid #a00; padding: 10px;">
        {{this.adminNotice}}
        <br/>
        <br/>
        <div style="text-align: right; display: block;">
          <i>This message is being shown to forum staff only, regular users will not see it.</i>
        </div>
      </div>
    {{/if}}
  </template>
};